import React, { memo } from 'react';
import WebsiteFilters from 'components/filters/WebsiteFilters';

export const FooterMenusFilters = memo(
  ({
    onFiltersChange,
    shoppingCenters = [],
    loadingShoppingCenters = false,
    filters = {},
  }) => {
    return (
      <WebsiteFilters
        shoppingCenters={shoppingCenters}
        onFiltersChange={onFiltersChange}
        loading={loadingShoppingCenters}
        showInsegna={false}
        showCategorie={false}
        enableSorting={true}
        filters={filters}
      />
    );
  },
);

FooterMenusFilters.displayName = 'FooterMenusFilters';

export default FooterMenusFilters;
